<template>
  <div class="pro-venue-events">
    <div class="pro-venue-events__header">
      <span class="pro-venue-events__title">
        {{ $t("wegow.profile.sections.events.title") }}
      </span>
      <span class="pro-venue-events__show-all" @click="showMoreConcerts()">
        {{ $t("general.header.dropdown.showAll") }}
      </span>
    </div>
    <div class="pro-venue-events__subtitle">
      <!-- <VueDatePicker
        v-model="date"
        class="pro-venue-events__subtitle--datepicker"
        :enable-time-picker="false"
        dark
        range
        :cancel-text="$t('general.cancel')"
        :select-text="$t('general.accept')"
        :locale="userStore.initialConfig.region"
        @update:model-value="onSelectDate"
      >
        <template #trigger>
          <div class="pro-venue-events__subtitle--date">
            <img
              src="@/assets/images/ic-calendar-topaz.svg"
              width="19"
              alt="calendar icon"
            />
            <span class="pro-venue-events__subtitle--date__text">
              {{ $t("provenue.selectDate") }}
            </span>
          </div>
        </template>
      </VueDatePicker> -->
    </div>
    <div class="pro-venue-events__carousel">
      <carousel
        v-if="relatedEvents.length > 0"
        ref="carouselRef"
        :transition="500"
        :wrap-around="false"
        v-bind="config"
        @mousedown="onMouseDown"
        @mousemove="onMouseMove"
        @mouseup="onMouseUp"
      >
        <slide v-for="(relatedEvent, index) in relatedEvents" :key="index">
          <event-card
            :event="relatedEvent"
            type="medium"
            :class="{ 'xs:ml-0 ml-[0.813rem]': index === 0 }"
            :is-link="openEvent"
          />
        </slide>
        <template #addons>
          <div class="custom--navigation">
            <div class="prev">
              <img
                src="@/assets/images/ic-chevron-left-gray.svg"
                alt="<"
                class="prev-img"
                @click="prev"
              />
            </div>
            <div class="next">
              <img
                src="@/assets/images/ic-chevron-right-gray.svg"
                alt="<"
                class="next-img"
                @click="next"
              />
            </div>
          </div>
        </template>
      </carousel>
      <div v-else class="no-events">
        <span>
          {{ $t("provenue.noEvents") }}
        </span>
      </div>
    </div>
  </div>
  <modal-profiles
    v-if="showModal"
    :title="$t('general.header.concerts')"
    type="medium"
    :gradient="eventStore.eventsToVenues.length > pageSize"
    :total-items="eventStore.eventsToVenues.length"
    :page="currentPage"
    :items-per-page="pageSize"
    @next-page="nextPage()"
    @close="closeConcertModal()"
  >
    <template #modalProfile>
      <section class="flex flex-wrap gap-[14px] relative">
        <div v-for="event in eventStore.eventsToVenues" :key="event.id">
          <event-card
            v-if="event"
            :event="event"
            type="small"
            :is-link="showLink"
            @empty-ad="eventStore.deleteAdRelatedToVenue($event)"
          />
        </div>
      </section>
    </template>
  </modal-profiles>
</template>

<script setup>
import { Carousel, Slide } from "vue3-carousel";
import EventCard from "@/components/wegow/ui/cards/EventCard.vue";
import { onMounted, ref, watch } from "vue";
import ModalProfiles from "../../modals/ModalProfiles.vue";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { useUserStore } from "@/stores/modules/user";
import { useEventStore } from "@/stores/modules/event";
import { useVenueStore } from "@/stores/modules/venue";

const emit = defineEmits(["onSelectDate"]);

const userStore = useUserStore();
const eventStore = useEventStore();
const venueStore = useVenueStore();

const props = defineProps({
  relatedEvents: {
    type: Array,
    default: () => []
  }
});

const config = ref({
  itemsToShow: 2,
  snapAlign: "start",
  breakpoints: {
    200: {
      itemsToShow: 1.8,
      snapAlign: "start"
    },
    500: {
      itemsToShow: 4.5,
      snapAlign: "start"
    },
    800: {
      itemsToShow: 4.5,
      snapAlign: "start"
    }
  }
});

const openEvent = ref(true);
const isEvent = ref(false);
const date = ref();
const showModal = ref(false);
const currentPage = ref(0);
const pageSize = ref(20);
const showLink = ref(true);
const carouselRef = ref();

onMounted(async () => {
  const startDate = new Date();
  const endDate = new Date(new Date());
  date.value = [startDate, endDate];
  await eventStore.getEventsToVenues({ venue: venueStore.details.id });
});

watch(
  currentPage,
  newCurrent => {
    venueStore.details.page = newCurrent;
    if (currentPage.value > 1) {
      eventStore.getEventsToVenueInfinite({ venue: venueStore.details.id });
    } else if (currentPage.value === 1) {
      venueStore.details.page_size = 10;
      eventStore.getEventsToVenues({ venue: venueStore.details.id });
    }
  },
  { immediate: true }
);

const onMouseDown = () => {
  isEvent.value = true;
};

const onMouseMove = () => {
  if (isEvent.value && openEvent.value) {
    openEvent.value = false;
  }
};

const onMouseUp = () => {
  if (isEvent.value) {
    setTimeout(() => {
      isEvent.value = false;
      openEvent.value = true;
    }, 250);
  }
};

const onSelectDate = () => {
  emit("onSelectDate", date.value);
};

const showMoreConcerts = () => {
  venueStore.details.page_size = pageSize.value;
  showModal.value = true;
  eventStore.getEventsToVenues({
    venue: venueStore.details.id,
    page_size: pageSize.value
  });
};

const nextPage = () => {
  currentPage.value++;
};

const closeConcertModal = () => {
  showModal.value = false;
  currentPage.value = 1;
};

const next = () => carouselRef.value.next();
const prev = () => carouselRef.value.prev();
</script>

<style lang="scss" scoped>
.pro-venue-events {
  height: 20.75rem;
  background: #000214;
  border-radius: 10px;
  padding: 24px;
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    justify-content: space-between; /* Asegura que los elementos estén en extremos opuestos */
    align-items: center; /* Alinea verticalmente los elementos */
  }

  &__title {
    font-size: 1.25rem;
    color: #fff; /* Asegúrate de que el color sea consistente */
  }

  &__show-all {
    color: #2effec;
    cursor: pointer;
    font-size: 14px;
    margin-left: auto; /* Asegura que el botón se alinee a la derecha */
  }

  &__subtitle {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    color: #2effec;
    cursor: pointer;
    font-size: 14px;

    @media (max-width: 768px) {
      flex-wrap: nowrap; /* Evita que los elementos se envuelvan */

      .pro-venue-events__subtitle--datepicker {
        display: none; // Oculta el VueDatePicker en dispositivos móviles
      }

      .pro-venue-events__show-all {
        margin-left: auto; // Mantiene el botón alineado a la derecha
      }
    }

    &--datepicker {
      width: auto;
      font-weight: 400;
    }

    &--date {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.25rem;

      &__text {
        font-family: "Museo Sans 500";
      }
    }
  }

  &__carousel {
    margin-top: 1.625rem;
    height: 100%;

    & > .no-events {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.custom--navigation {
  & > .prev {
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    background: rgb(0, 2, 20);
    background: linear-gradient(
      90deg,
      rgba(0, 2, 20, 1) 0%,
      rgba(28, 29, 41, 0) 100%
    );
  }

  & > .next {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    background: rgb(0, 2, 20);
    background: linear-gradient(
      270deg,
      rgba(0, 2, 20, 1) 0%,
      rgba(28, 29, 41, 0) 100%
    );
  }
}

@media (max-width: 768px) {
  .pro-venue-events__carousel {
    .event-card {
      max-width: 150px; // Reduce el ancho máximo en móviles
      height: 200px; // Ajusta automáticamente la altura para mantener la proporción
      margin: 0 auto; // Centra las cartas
    }
  }
}
</style>
